import { WebGLRenderer } from 'three';
import WebXRPolyfill from 'webxr-polyfill';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const polyfill = new WebXRPolyfill({
  webvr: true,
  cardboard: true,
  allowCardboardOnDesktop: {
    DIRTY_SUBMIT_FRAME_BINDINGS: true,
  },
  // allowCardboardOnDesktop: true,
});

class VRModeAdapter {
  renderer: WebGLRenderer;
  isSupported: boolean;
  currentSession: any;

  constructor(renderer: WebGLRenderer) {
    this.renderer = renderer;
    this.isSupported = false;
    this.currentSession = null;

    if ('xr' in navigator) {
      navigator.xr
        .isSessionSupported('immersive-vr')
        .then((supported: boolean) => {
          if (supported) {
            this.isSupported = true;
          } else {
            this.isSupported = false;
          }
          // supported ? showEnterVR() : showWebXRNotFound();
        })
        .catch((e: any) => {
          console.error('VRModeAdapter: immersive-vr: ', e);
          this.isSupported = false;
        });
    } else {
      if (window.isSecureContext === false) {
        console.error('WEBXR NEEDS HTTPS');
      } else {
        console.error('WEBXR NOT AVAILABLE');
      }
    }
  }

  enterVR = () => {
    if (!this.isSupported) {
      this.enterFullScreen();
    } else if (this.currentSession === null) {
      // WebXR's requestReferenceSpace only works if the corresponding feature
      // was requested at session creation time. For simplicity, just ask for
      // the interesting ones as optional features, but be aware that the
      // requestReferenceSpace call will fail if it turns out to be unavailable.
      // ('local' is always available for immersive sessions and doesn't need to
      // be requested separately.)

      const sessionInit = { optionalFeatures: ['local-floor', 'bounded-floor', 'hand-tracking'] };
      navigator.xr
        .requestSession('immersive-vr', sessionInit)
        .then(this.onSessionStarted)
        .catch((e: any) => {
          console.error('VRModeAdapter: enterVR: ', e);

          this.enterFullScreen();
        });
    }
  };

  exitVR = () => {
    if (this.currentSession !== null) {
      this.currentSession.end();
    } else {
    }
  };

  private onSessionStarted = (session: any) => {
    session.addEventListener('end', this.onSessionEnded);

    this.renderer.xr.setSession(session);

    this.currentSession = session;

    this.renderer.domElement.dispatchEvent(new CustomEvent('custom-enter-vr'));
  };

  private onSessionEnded = () => {
    this.currentSession.removeEventListener('end', this.onSessionEnded);

    this.currentSession = null;

    this.renderer.domElement.dispatchEvent(new CustomEvent('custom-exit-vr'));
  };

  private enterFullScreen = () => {
    const element = this.renderer.domElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
      //@ts-ignore
    } else if (element.webkitRequestFullscreen) {
      //@ts-ignore
      element.webkitRequestFullscreen();
      //@ts-ignore
    } else if (element.mozRequestFullScreen) {
      //@ts-ignore
      element.mozRequestFullScreen();
      //@ts-ignore
    } else if (element.msRequestFullscreen) {
      //@ts-ignore
      element.msRequestFullscreen();
    } else {
      return false;
    }
  };
}

export default VRModeAdapter;
